import type { SfJQuery } from '@app/types'
import type { ProgressChecker, ProgressCheckerManager } from './types'

import $ from 'jquery'
import createProgressChecker from './progress-checker'

const createProgressCheckerManager = ({
  containerElements,
}: {
  containerElements?: HTMLElement[]
}): ProgressCheckerManager => {
  let progressCheckers: ProgressChecker[] = []
  const containers = containerElements || []

  const spawnProgressChecker = (progressPath: string): void => {
    progressCheckers.push(
      createProgressChecker({ progressPathPayload: progressPath })
    )
  }

  const updateContainers = (container: HTMLElement): void => {
    containers.push(container)
  }

  const uninstallProgressChecker = (progressPath: string): void => {
    const progressChecker = findProgressCheckerByPath(progressPath)
    if (progressChecker) {
      progressChecker.teardown()
      progressCheckers = progressCheckers.filter(
        (checker) => checker.getProgressPath() === progressPath
      )
    }
  }

  const findProgressCheckerByPath = (
    progressPath: string
  ): ProgressChecker | undefined => {
    return progressCheckers.find(
      (progressChecker) => progressChecker.getProgressPath() === progressPath
    )
  }

  const teardown = (): void => {
    window.eventHub.$off('progress-checker:uninstall', uninstallProgressChecker)
    window.eventHub.$off('progress-checker:replace-html', replaceContainerHtml)
    window.eventHub.$off(
      'progress-checker:add-html-to-container',
      addHtmlToContainer
    )
    progressCheckers.forEach((progressChecker) => {
      progressChecker.teardown()
    })
    progressCheckers = []
  }

  const replaceContainerHtml = (html: string): void => {
    containers.forEach((container) => {
      const $html = $(html) as SfJQuery
      $(container).replaceWith($html)

      if ($html.initializeDom) {
        $html.initializeDom()
      }
    })
  }

  const addHtmlToContainer = (statusUpdate: string): void => {
    containers.forEach((container) => {
      const subContainers = container.querySelectorAll(
        "[data-behaviour~='progress-checker-status']"
      )

      subContainers.forEach((subContainer) => {
        subContainer.innerHTML = ''
        subContainer.insertAdjacentHTML('afterbegin', statusUpdate)
      })
    })
  }

  window.eventHub.$on('progress-checker:replace-html', replaceContainerHtml)
  window.eventHub.$on(
    'progress-checker:add-html-to-container',
    addHtmlToContainer
  )
  window.eventHub.$on('progress-checker:uninstall', uninstallProgressChecker)

  return {
    teardown,
    createProgressChecker: spawnProgressChecker,
    updateContainers,
    findProgressCheckerByPath,
  }
}

export default createProgressCheckerManager
